<template>
  <div id="lottery">
    <div class="main">
        <div class="left" @click="transLeft(1)"></div>
        <div class="right" @click="transLeft(0)"></div>
        <div class="wrapper">

            <ul :style="'width:'+(list.length*210+145)+'px;min-width:1195px;transition:all .5s;color:red;transform:translateX('+leftLate+'px);'">
                <li
                    v-for="(item, index) in list"
                    :key="index"
                    @mouseenter="enter(index)"
                    :class="{ active: active == index }"
                    @click="getToken(item,2)"
                >
                    <div class="normal">
                    <div class="title" :class="{'actTitle':active == index}">{{item.name}}</div>
                    <div class="img">
                        <img loading="lazy" v-lazy="item.imgUrl?item.imgUrl:default_list[0].img" alt="">
                    </div>
                    <div class="enter" v-show=" active == index "></div>
                    </div>
                </li>
            </ul>
        </div>
        </div>
    <!-- <ul>
        <li v-for="(item, index) in list" :key="index" @click="getToken(item,2)">
            <div class="mask"><span>{{item.name}}</span></div>
            <img loading="lazy" v-lazy="item.imgUrl?item.imgUrl:default_list[0].img">
            <span class="title">{{item.name}}</span>
        </li>
    </ul> -->
  </div>
</template>

<script>
export default {
  name: "lottery",
  data() {
    return {
        leftLate:0, // 位移
        active: 0,
        default_list:[
            {img:require('@/assets/images/mb/live-bg1.png')}
        ],
        
        list: [],
    };
  },
  computed:{},
  mounted(){
    this.getDataType()
  },
  methods: {
    // 进入游戏
        getToken: async function(req,index) {
            let self = this;
                var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
                
            if (!self.$common.getUser()) {
                self.$message.warning(self.$t('indexPage.pleaseLogin'))
                return
            }
            self.tenantId = self.$common.getUser().tenant_id
            self.username = self.$common.getUser().username
            self.uid = self.$common.getUser().user_id
            let datas = {
                tenantId: self.tenantId,
                username: self.username,
                gameId: index == 2?req.ids:req.id,
                clientIp: self.$config.clientIp,
                memberId: self.uid,
                terminalType: 1
            }
            self.$common.setGameRequestData(datas)
            
            const res = await self.$http.post(this.$api.getToken, datas, true)
            if (res.code == 0) {
                self.gameUrl = res.data;
                if (req.openMode === 1) {
                // if(issafariBrowser) {
                    //  self.winOpen.location.href = self.gameUrl;
                // }else{
                    window.open(self.gameUrl)
                // }
                
                }else{
                    window.open(self.gameUrl)
                }

            } else {
              self.$message.error(self.$t('indexPage.repair'))
                // if (req.openMode === 1) {
                // window.open('/error.html?type=1')
                // // self.winOpen.location.href = '/error.html?type=1';
                // }
                
                // if (req.status === 0) {
                // self.$message.error(self.$t('indexPage.repair'))
                // }else{
                // self.$message.error(self.$t('indexPage.failed'))
                // }
            }
        },
    // 获取数据列表
    getDataType(){
      let result = JSON.parse(localStorage.getItem('game_menus_pc'));
      this.list = result.data.cp;
    },
    transLeft(val){
      let num = this.list.length*210+145 - 1195
      if(val == 0){
        if(this.leftLate - 210 + num > 0){
          this.leftLate -= 210;
        }else{
          this.leftLate = -num;
        }
      }
      else {
        if(this.leftLate + 210 > 0){
          this.leftLate = 0;
        }else {
          this.leftLate += 210
        }
      }
    },
    enter(index) {
      this.active = index;
    },
  },
};
</script>

<style lang="scss" scoped>
#lottery {
    background: #000 url('../../assets/images/amjs/listbg5.jpg') no-repeat;
    background-position: center top;
    padding-top: 560px;
    background-size: cover;
    .main {
    position: relative;
    height: 300px;
    width: 1400px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 100px;
    // overflow-x:auto;
    .left {
      position: absolute;
      left: 20px;
      top: 50%;
      width: 50px;
      height: 50px;
      color:#fff;
      z-index:100;
      cursor:pointer;
      background: url('../../assets/images/mb/left-icon.png') no-repeat;
      background-size: contain;
    }
    .right {
      position: absolute;
      right: 20px;
      top: 50%;
      width: 50px;
      height: 50px;
      color:#fff;
      z-index:100;
      cursor:pointer;
      background: url('../../assets/images/mb/right-icon.png') no-repeat;
      background-size: contain;
    }
    .wrapper {
      width: 1195px;
      height: 300px;
      overflow: auto;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      ul {
        position: relative;
        margin: 0 auto;
        display: flex;
        height: 100%;
        white-space: nowrap;
        li {
          position: relative;
          width: 210px;
          box-sizing: border-box;
          transition: all 0.3s;
          background: url('../../assets/images/mb/live_bg.png') no-repeat;
          background-size: cover;
          border-left: 2px solid #080808;
          position: relative;
          .normal {
              position: relative;
              width: 100%;
              height: 100%;
              cursor: pointer;
            .title {
              position: absolute;
              width: 120px;
              height: 30px;
              line-height: 30px;
              font-size:22px;
              font-weight:normal;
              text-align: center;
              right: 10px;
              top: 40px;
              background-image: linear-gradient(180deg,#ccc9e6,#937ce7);
              -webkit-background-clip:text;
              color: transparent;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              
            }
            .actTitle {
              text-align: left;
            }
            .img {
              position: absolute;
              left: 0;
              bottom: 0;
              width: 210px;
              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                object-position: left bottom;
              }
            }
            .intro {
              position: absolute;
              right: 0;
              bottom: 190px;
              width: 230px;
              height: 30px;
              // border:1px solid gold;
              // border-radius:24px;
              font-size: 16px;
              color:white;
              text-shadow: 1px 1px 0 #da83ff;
            
              text-align: left;
              line-height: 30px;
            }
            .enter {
              position: absolute;
              right: 30px;
              bottom: 100px;
              width: 130px;
              height: 48px;
              // border:1px solid gold;
              border-radius:24px;
              background: url('../../assets/images/mb/enter1.png') no-repeat;
              background-size: cover;
              text-align: center;
              line-height: 48px;
            }
          }
        }
  
        li.active {
          width: 355px;
          overflow: hidden;
          background: url(../../static/image/pn/activeBg.jpg) no-repeat;
          .title {
            right: 90px;
            font-weight: bold;
            font-size:26px;
            background-image: 0 none;
            color: #fff;
            text-shadow: 1px 1px 0 #e99b65;
          }
        }
      }
    }
    }
}
</style>
